export enum ShipmentStatus {
  CompliancePending = 'compliancePending',
  Tracking = 'tracking',
  Completed = 'completed',
  Mixed = 'mixed', // NOTE: Never set on shipments, used only for the all and filtered tabs as table state
}
